// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37501057","796":"28af6da8","966":"97d053d3"}[chunkId] + ".chunk.js";
};